import { useState } from "react";
import { toast } from "sonner";
import { ErrorTags, reportAppError } from "../../errorReporter";
import { endpoints } from "../../hooks/endpoints";
import { getToken } from "../../hooks/utils";

const QashqoolNativeApp = () => {
  const [loadingWindows, setLoadingWindows] = useState(false);
  const [loadingMac, setLoadingMac] = useState(false);

  const handleDownload = async (platform: "win32" | "darwin") => {
    const setLoading = platform === "win32" ? setLoadingWindows : setLoadingMac;

    try {
      setLoading(true);

      const response = await fetch(
        `${endpoints.getQashqoolAppDownloadUrl}?platform=${platform}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: getToken(),
          },
          method: "POST",
          body: JSON.stringify({
            platform,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to get download URL: ${response.statusText}`);
      }

      const data = await response.json();

      if (data.presigned_url) {
        // Create a temporary anchor element to trigger download
        const link = document.createElement("a");
        link.href = data.presigned_url;
        link.download =
          platform === "win32" ? "QashqoolSetup.exe" : "Qashqool.dmg";
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        throw new Error("No download URL received from server");
      }
    } catch (error) {
      const err = error as Error;
      reportAppError({
        e: err,
        info: `Error downloading Qashqool app for ${platform}`,
        errorTag: ErrorTags.LessonScreen,
      });
      toast.error(`فشل تحميل التطبيق. الرجاء المحاولة مرة أخرى.`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container px-4">
      <div
        className="border border-red-400 bg-red-100 text-red-700 rounded-ea my-2 text-xl p-2 leading-10"
        role="alert"
      >
        هذا المحتوى محمي , يجب الدخول على الحصة من خلال برنامج كشكول على
        الدسكتوب أو متصفح Xvast على الموبايل, متصفح Xvast يشبه جوجل كروم و يمكنك
        إستخدامه للدخول على أي موقع , بعد التحميل افتح متصفح Xvast و ادخل منه
        على الموقع كأنك تستعمل جوجل كروم
      </div>
      <div className="flex flex-wrap gap-x-4 justify-center">
        <button
          className="no-underline bg-primary text-white py-2 px-3 m-2 rounded-ea disabled:opacity-50 disabled:cursor-not-allowed hover:cursor-pointer"
          onClick={() => handleDownload("win32")}
          disabled={loadingWindows}
        >
          تحميل تطبيق كشكول للوندوز
        </button>
        <button
          className="no-underline bg-primary text-white py-2 px-3 m-2 rounded-ea disabled:opacity-50 disabled:cursor-not-allowed hover:cursor-pointer"
          onClick={() => handleDownload("darwin")}
          disabled={loadingMac}
        >
          تحميل تطبيق كشكول للماك
        </button>
        <a
          className="no-underline bg-primary text-white py-2 px-3 m-2 rounded-ea"
          href="https://www.drm-x.com/download/Xvast.apk"
        >
          تحميل Xvast للأندرويد
        </a>
        <a
          className="no-underline bg-primary text-white py-2 px-3 m-2 rounded-ea"
          href="https://itunes.apple.com/us/app/xvast/id1239299799?mt=8"
        >
          تحميل Xvast للأيفون
        </a>
      </div>
    </div>
  );
};

export default QashqoolNativeApp;
